interface ErrorLog {
  timestamp: string;
  level: 'error' | 'warning' | 'info';
  message: string;
  details?: any;
  userAgent?: string;
  url?: string;
  userId?: string;
  userType?: string;
}

class ErrorLogger {
  private logs: ErrorLog[] = [];
  private maxLogs = 100; // Manter apenas os últimos 100 logs

  private addLog(level: ErrorLog['level'], message: string, details?: any) {
    const log: ErrorLog = {
      timestamp: new Date().toISOString(),
      level,
      message,
      details,
      userAgent: navigator.userAgent,
      url: window.location.href,
    };

    // Adicionar informações do usuário se disponível
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      if (user.id) {
        log.userId = user.id;
        log.userType = user.tipo;
      }
    } catch (error) {
      // Ignorar erro ao tentar obter dados do usuário
    }

    this.logs.push(log);

    // Manter apenas os últimos logs
    if (this.logs.length > this.maxLogs) {
      this.logs = this.logs.slice(-this.maxLogs);
    }

    // Salvar no localStorage
    this.saveLogs();

    // Log no console em desenvolvimento
    if (process.env.NODE_ENV === 'development') {
      console.group(`[${level.toUpperCase()}] ${message}`);
      console.log('Timestamp:', log.timestamp);
      console.log('Details:', details);
      console.log('URL:', log.url);
      console.groupEnd();
    }
  }

  private saveLogs() {
    try {
      localStorage.setItem('error_logs', JSON.stringify(this.logs));
    } catch (error) {
      // Se não conseguir salvar, limpar logs antigos
      this.logs = this.logs.slice(-50);
      try {
        localStorage.setItem('error_logs', JSON.stringify(this.logs));
      } catch {
        // Se ainda não conseguir, limpar completamente
        this.logs = [];
      }
    }
  }

  private loadLogs() {
    try {
      const savedLogs = localStorage.getItem('error_logs');
      if (savedLogs) {
        this.logs = JSON.parse(savedLogs);
      }
    } catch (error) {
      this.logs = [];
    }
  }

  constructor() {
    this.loadLogs();
  }

  error(message: string, details?: any) {
    this.addLog('error', message, details);
  }

  warning(message: string, details?: any) {
    this.addLog('warning', message, details);
  }

  info(message: string, details?: any) {
    this.addLog('info', message, details);
  }

  getLogs(): ErrorLog[] {
    return [...this.logs];
  }

  clearLogs() {
    this.logs = [];
    localStorage.removeItem('error_logs');
  }

  downloadLogs() {
    const dataStr = JSON.stringify(this.logs, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `error-logs-${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}

export const errorLogger = new ErrorLogger();
